var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5C12.2308 7.8018 12.9453 8.99916 14.0312 9.90412C15.1172 10.8091 16.5131 11.3704 18 11.5M13.424 4.14717L4.18525 14.0937C3.83641 14.4714 3.49881 15.2154 3.4313 15.7305L3.01493 19.439C2.86864 20.7781 3.8139 21.6938 5.11926 21.4649L8.74274 20.8354C9.24913 20.7438 9.95807 20.3661 10.3069 19.9769L19.5457 10.0304C21.1436 8.3135 21.8638 6.35624 19.3769 3.96403C16.9012 1.59472 15.022 2.43028 13.424 4.14717Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e3d3441d000f3f7f22630d074639bc65.svg";
export { ForwardRef as ReactComponent };